import * as React from 'react'
import Channels from '../../../../../../constants/Channels'
import EbayRelistDialog from '../../../../../listing_manager/ebay/RelistDialog'
import ShopgoodwillRelistDialog from '../../../../../listing_manager/shopgoodwill/RelistDialog'
import BulkListDialog from '../../../../../listing_manager/shopify/BulkListDialog'
import { ProductV4 } from '../../../../../../types/api'
import { RelistDialog } from '../../../../../listing_manager/goodwillfinds/RelistDialog'

interface Props {
  product: ProductV4
  channelId?: number
  marketAccountId?: number // only necessary for shopify to load in the proper defaults
  onClose: () => void
  onSubmit: (number, any, Function) => void
}

export const MoveDialog: React.FC<Props> = props => {
  switch (props.channelId) {
    case Channels.SHOPGOODWILL.id:
      return (
        <ShopgoodwillRelistDialog
          data={['move_to_product']}
          onClose={props.onClose}
          actionTitle="Move"
          onSubmit={(shopgoodwillListing, callback) =>
            props.onSubmit(props.channelId, { shopgoodwillListing }, callback)
          }
          isOpen
        />
      )

    case Channels.EBAY.id:
      return (
        <EbayRelistDialog
          data={['move_to_product']}
          onClose={props.onClose}
          actionTitle="Move"
          marketAccountId={props.marketAccountId}
          onSubmit={(ebayListing, callback) => props.onSubmit(props.channelId, { ebayListing }, callback)}
          isOpen
        />
      )

    case Channels.GOODWILLFINDS.id:
      return (
        <RelistDialog
          data={['move_to_product']}
          onClose={props.onClose}
          actionTitle="Move"
          marketAccountId={props.marketAccountId}
          onSubmit={(goodwillfindsListing, callback) =>
            props.onSubmit(props.channelId, { goodwillfindsListing }, callback)
          }
          isOpen
        />
      )

    case Channels.SHOPIFY.id:
      return (
        <BulkListDialog
          action="move"
          data={['move_to_product']}
          aProductHasVariants={props.product.variants?.length > 0}
          onClose={props.onClose}
          actionTitle="Move"
          marketAccountId={props.marketAccountId}
          onSubmit={(shopifyListing, callback) => props.onSubmit(props.channelId, { shopifyListing }, callback)}
          isOpen
        />
      )
    default:
      return null
  }
}
